<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to annual summary" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="payroll" pageId="annualization" color="white"></help-link>
                    <v-btn v-if="hasAnnualizationData" @click="showReportsMenu" dark icon small title="Print Reports" :disabled="hasMissingCompanyDetails">
                        <v-icon>fa-solid fa-file</v-icon>
                    </v-btn>
                    <v-menu v-if="hasEditRights||hasApproverRights" left v-model="menu_status" offset-y :disabled="isClosedFiscalPeriod">  
                        <template v-slot:activator="{ on }">
                            <v-btn :class="overAllStatus.class" dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;{{overAllStatus.status}}&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile v-if="hasEditRights" :key="0" @click="processAll" title="Process annualization for valid records">
                                <v-list-tile-title>Process ({{forProcessCount}})</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if="hasEditRights" :key="0" @click="forReviewAll" title="Set all Created to For Review">
                                <v-list-tile-title>For Review ({{createdCount}})</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if="hasApproverRights" :key="1" @click="approveAll" title="Approve all For Review">
                                <v-list-tile-title>Approve ({{forReviewCount}})</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if="hasEditRights" :key="2" @click="adjustmentsProcessed" title="Set all Approved to Adjustments Processed">
                                <v-list-tile-title>Adjustments Processed ({{approvedCount}})</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
            </v-card>

            <v-alert v-if="!loading&&hasMissingCompanyDetails" :value="true" color="warning" icon="warning" outline >
                Company details have not been set up yet. Please update them on the <span @click="$router.push('/company/account')"><u style="cursor:pointer;"><b>Company Account</b></u> page.</span>
            </v-alert> 
            <v-alert v-if="error" :value="true" color="error" icon="error" outline >
                Error encountered. Please contact support.
            </v-alert>  
            <v-alert v-if="isClosedFiscalPeriod" :value="true" color="warning" icon="warning" outline >
                This Calendar period is already closed.
            </v-alert>  
            
            <!-- details -->
            <v-card class="elavation-1" style="margin-top:5px;"> 
                <v-toolbar flat height="45px">
                    <div class="wp-30 mb-10">
                        <v-text-field v-model="search" append-icon="search" label="Search name, team" single-line hide-details></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                    <span v-if="unProcessedCount>0" class="orange--text">
                        <b>{{unProcessedCount}} Unprocessed</b>
                    </span>
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="annualization_list_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item)" title="Click to view annualization details" style="cursor:pointer;">
                            <td>
                                <v-chip style="margin-left:-5px;">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                    </v-avatar>
                                    {{props.item.firstName}} {{props.item.lastName}}
                                </v-chip>
                            </td>
                            <td>
                                <team-chips :teams="props.item.teams"></team-chips>
                            </td>
                            <td>{{props.item.position}}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.employmentStatus)">{{commonfn.getStatusDescription(props.item.employmentStatus)}}</b>
                            </td>
                            <!-- <td>
                                <span v-if="props.item.payGrade==null" class="red--text">Not Updated</span>
                                <span v-else>{{props.item.payGrade}}</span>
                            </td> -->
                            <td>
                                <span :class="commonfn.getStatusColor(props.item.payrollStatus)">{{commonfn.getStatusDescription(props.item.payrollStatus)}}</span>
                            </td>
                            <td>
                                <span :class="commonfn.getStatusColor(props.item.annualizationStatus)">{{commonfn.getStatusDescription(props.item.annualizationStatus)}}</span>
                            </td>
                            <td>
                                <div class="text-xs-right">
                                    <b>{{numFormat.formatNumber(props.item.finalAdjustments)}}</b>
                                </div>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogReports" persistent width="670">
            <reports ref="reportsRef" :dialogReports.sync="dialogReports"></reports>
        </v-dialog>

        <v-dialog v-model="dialogProcessing" width="600" persistent>
            <batch-processing 
                :dialogProcessing.sync="dialogProcessing"
                :processingText="processingText"
                :processingValue="processingValue"
                :processed="processed"
                :failedItems="failedItems"
                :loadingProcessing="loadingProcessing"
                ></batch-processing>
        </v-dialog>

        <v-snackbar v-model="snackbar" :bottom="y === 'top'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :right="x === 'right'" :timeout="6000" :top="y === 'top'" :vertical="mode === 'vertical'"
            >{{snackbarText}}
            <v-btn color="primary" flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>

<script>

import annualizationApi from '@/api/annualization'
import commonfn from '@/common/functions'
import updateHistApi from '@/api/updateshistory'
import numFormat from '@/common/num_format'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import awsS3Helper from '@/helpers/aws-s3'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {     
    name: 'Annualization',
    metaInfo: {
        title: 'Annualization',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View/edit Annualization' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'reports': () => import('@/components/Annualization/AnnualizationSummaryReports'),
        'team-chips': () => import("@/components/Common/TeamsChip"),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory'),
        'batch-processing': () => import('@/components/Common/BatchProcessingContent'),
    },
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            numFormat,
            commonfn,
            awsS3Helper,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            headers: [
                {text:'Employee', align:'left', value: 'lastName', width:'15%', sortable:true},
                {text:'Teams', align:'left', value: 'employeeId', width:'20%', sortable:true},
                {text:'Position', align:'left', value:'position', width:'15%', sortable:true},
                {text:'Employment Status', align:'left', value:'employmentStatus', width:'15%', sortable:true},
                // {text:'Pay Grade', align:'left', value:'payGrade', width:'15%', sortable:true},
                {text:'Payroll Status', align:'left', value:'payrollStatus', width:'5%', sortable:true},
                {text:'Annualization Status', align:'left', value:'annualizationStatus',width: '10%', sortable:true},
                {text:'Final Adjustments', align:'right', value:'finalAdjustments', width: '5%', sortable:true}
            ],
            search: userPrefs.getSearchKeyword(routeName),
            y:null,
            x:null,
            mode: null,
            snackbar: false,
            snackbarText: null,
            error: false,
            errorMessage: '',
            loading: false,
            loading_years: false,
            menu_year: false,
            dialogReports: false,
            loading_status: false,
            menu_status: false,
            annualization_list: [],
            fiscal_period: null,            
            company_details: null,

            //for batch processing progress indicator
            processingText: '',
            processingValue: 0,
            loadingProcessing: false,
            dialogProcessing: false,
            processed: 0,
            failed: 0,
            failedItems: [],
        }
    },
    methods: {  
        async processAll() {
            try {
                // Enable batch UI dialog
                this.loadingProcessing = true
                this.dialogProcessing = true
                this.processingValue = 0
                this.failedItems = []
                this.processed = 0
                this.failed = 0

                // Determine valid items to process
                const itemsToProcess = this.annualization_list_filtered.filter(item => {
                    return item.payrollStatus == commonfn.getStatusCode('Completed') &&
                        (
                            item.annualizationStatus == commonfn.getStatusCode('Not Available') ||
                            item.annualizationStatus == commonfn.getStatusCode('Created') ||
                            item.annualizationStatus == commonfn.getStatusCode('Rejected')
                        )
                }).length

                if (itemsToProcess === 0) {
                    this.processingText = "No valid items to process"
                    this.loadingProcessing = false
                    return
                }

                const incrementBy = 100 / itemsToProcess

                // Batch process loop
                for (const item of this.annualization_list_filtered) {

                    const isCompleted = item.payrollStatus == commonfn.getStatusCode('Completed');
                    const isStatusValid =
                        item.annualizationStatus == commonfn.getStatusCode('Not Available') ||
                        item.annualizationStatus == commonfn.getStatusCode('Created') ||
                        item.annualizationStatus == commonfn.getStatusCode('Rejected');

                    if (isCompleted && isStatusValid && !item.deactivated) {

                        // Update UI text + progress
                        this.processingText = `Processing ${this.processed + this.failed + 1} of ${itemsToProcess}`
                        this.processingValue += incrementBy

                        try {
                            // API call
                            const data = {
                                userId: item.userId,
                                fiscalPeriodId: this.fiscalPeriodId
                            }
                            await annualizationApi.compute(data)
                            this.processed += 1

                        } catch (err) {
                            this.failed += 1
                            this.failedItems.push({
                                name: `${item.firstName} ${item.lastName}`,
                                userId: item.userId,
                                employeeId: item.employeeId
                            })
                        }
                    }
                }

                // Refresh data after batch run
                await this.getAnnualization(false)

                // History entry
                await this.updateHistory(
                    `Processed: ${this.processed} processed, ${this.failed} failed`
                )

                this.processingText = "Batch Processing Completed"
                this.loadingProcessing = false

            } catch (error) {
                this.error = true
                this.errorMessage = error
                this.loadingProcessing = false
            }
        },
        async adjustmentsProcessed() {
            try {
                // Activate batch dialog + reset state
                this.loadingProcessing = true
                this.dialogProcessing = true
                this.processingValue = 0
                this.failedItems = []
                this.processed = 0
                this.failed = 0

                const itemsToProcess = this.annualization_list_filtered.filter(
                    x =>
                        x.annualizationStatus == commonfn.getStatusCode('Approved') &&
                        x.finalAdjustments >= 0
                ).length

                if (itemsToProcess === 0) {
                    this.processingText = "No valid items to process"
                    this.loadingProcessing = false
                    return
                }

                const incrementBy = 100 / itemsToProcess

                for (const item of this.annualization_list_filtered) {

                    const isApproved = item.annualizationStatus == commonfn.getStatusCode('Approved')
                    const isValid = item.finalAdjustments >= 0

                    if (isApproved && isValid) {

                        this.processingText = `Processing ${this.processed + this.failed + 1} of ${itemsToProcess}`
                        this.processingValue += incrementBy

                        const data = {
                            annualizationId: item.annualizationId
                        }

                        try {
                            await annualizationApi.adjustmentsProcessed(data)
                            this.processed += 1
                        } catch (err) {
                            this.failed += 1
                            this.failedItems.push({
                                name: `${item.firstName} ${item.lastName}`,
                                userId: item.userId,
                                employeeId: item.employeeId
                            })
                        }
                    }
                }

                // Refresh data after processing
                await this.getAnnualization(false)

                // Log the batch activity
                await this.updateHistory(
                    `Adjustments Processed: ${this.processed} processed, ${this.failed} failed`
                )

                this.processingText = "Batch Processing Completed"
                this.loadingProcessing = false

            } catch (error) {
                this.error = true
                this.errorMessage = error
                this.loadingProcessing = false
            }
        },
        async forReviewAll() {
            try {
                // Activate dialog and reset states
                this.loadingProcessing = true
                this.dialogProcessing = true
                this.processingValue = 0
                this.failedItems = []
                this.processed = 0
                this.failed = 0

                // Count valid items before processing
                const itemsToProcess = this.annualization_list_filtered.filter(
                    x => x.annualizationStatus == commonfn.getStatusCode('Created')
                ).length

                if (itemsToProcess === 0) {
                    this.processingText = "No valid items to process"
                    this.loadingProcessing = false
                    return
                }

                const incrementBy = 100 / itemsToProcess

                // Process each item
                for (const item of this.annualization_list_filtered) {
                    if (item.annualizationStatus == commonfn.getStatusCode('Created')) {

                        this.processingText = `Processing ${this.processed + this.failed + 1} of ${itemsToProcess}`
                        this.processingValue += incrementBy

                        const data = {
                            annualizationId: item.annualizationId
                        }

                        try {
                            await annualizationApi.forReview(data)
                            this.processed += 1
                        } catch (err) {
                            this.failed += 1
                            this.failedItems.push({
                                name: `${item.firstName} ${item.lastName}`,
                                userId: item.userId,
                                employeeId: item.employeeId
                            })
                        }
                    }
                }

                await this.getAnnualization(false)

                // Update history
                await this.updateHistory(
                    `For Review: ${this.processed} processed, ${this.failed} failed`
                )

                this.processingText = "Batch Processing Completed"
                this.loadingProcessing = false

            } catch (error) {
                this.error = true
                this.errorMessage = error
                this.loadingProcessing = false
            }
        },
        async approveAll() {
            try {
                // Activate batch dialog + reset state
                this.loadingProcessing = true
                this.dialogProcessing = true
                this.processingValue = 0
                this.failedItems = []
                this.processed = 0
                this.failed = 0

                const itemsToProcess = this.annualization_list_filtered.filter(
                    x => x.annualizationStatus == commonfn.getStatusCode('For Review')
                ).length

                if (itemsToProcess === 0) {
                    this.processingText = "No valid items to approve"
                    this.loadingProcessing = false
                    return
                }

                const incrementBy = 100 / itemsToProcess

                for (const item of this.annualization_list_filtered) {

                    const isForReview =
                        item.annualizationStatus == commonfn.getStatusCode('For Review')

                    if (isForReview) {

                        this.processingText = `Processing ${this.processed + this.failed + 1} of ${itemsToProcess}`
                        this.processingValue += incrementBy

                        const data = {
                            annualizationId: item.annualizationId
                        }

                        try {
                            await annualizationApi.approve(data)
                            this.processed += 1
                        } catch (err) {
                            this.failed += 1
                            this.failedItems.push({
                                name: `${item.firstName} ${item.lastName}`,
                                userId: item.userId,
                                employeeId: item.employeeId
                            })
                        }
                    }
                }

                // Refresh list after processing
                await this.getAnnualization(false)

                // Log batch activity
                await this.updateHistory(
                    `Approved: ${this.processed} processed, ${this.failed} failed`
                )

                this.processingText = "Batch Processing Completed"
                this.loadingProcessing = false

            } catch (error) {
                this.error = true
                this.errorMessage = error
                this.loadingProcessing = false
            }
        },
        async updateHistory(updateAction) {
            try {
                var data = {
                    pageQueryId: this.pageQueryId,
                    updateAction: updateAction
                }
                await updateHistApi.send(data)
            }catch(error){
                this.errorMessage = error
                this.error = true
            }
        },
        showReportsMenu() {
            var data = {
                fiscalPeriodId: this.fiscalPeriodId,
                fiscalYear: this.selectedYear
            }
            this.$refs.reportsRef.setParam(data)
            this.dialogReports=true
        },
        viewDetails(data) {
            this.$router.push(`/payroll/annualization/${this.fiscalPeriodId}/${data.userId}`)
        },
        async getAnnualization(show_loading) {
            try {
                this.loading = show_loading
                const response = await annualizationApi.getByFiscalPeriod(this.fiscalPeriodId)
                if (response && response.status == 200) {
                    this.annualization_list = response.data.items
                    this.fiscal_period = response.data.fiscalPeriod
                    this.company_details = response.data.company
                }
                this.loading = false
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) this.getAnnualization(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    async created() { 
        await this.getAnnualization(true)

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: `${this.selectedYear} Payroll Annualization`
        })
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            userPrefs.updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        annualization_list_filtered() {
            var temp = this.annualization_list

            //search handler
            if (this.search) {
                const searchLower = this.search.toLowerCase()
                temp = temp.filter(item => {
                    const firstNameMatch = item.firstName.toLowerCase().includes(searchLower)
                    const lastNameMatch = item.lastName.toLowerCase().includes(searchLower)
                    const teamsMatch = Array.isArray(item.teams)
                        ? item.teams.join(', ').toLowerCase().includes(searchLower)
                        : false
                    return firstNameMatch || lastNameMatch || teamsMatch
                })
            }
            return temp
        },
        fiscalPeriodId() {
            return this.$route.params.fiscalPeriodId
        },
        pageQueryId() {
            return `annualization-summary-${this.fiscalPeriodId}`
        },
        commentsData() {
            if (!this.loading) {
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: null,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.annualization,
                    notificationTypeId: notificationTypes.annualization_summary
                }
            }
        },
        hasEditAndApproverRights() {
            return this.hasEditRights && this.hasApproverRights
        },
        hasEditRights() {
            return commonfn.hasEditRights(this.$router.currentRoute.path)
        },
        hasApproverRights() {
            return commonfn.hasApproverRights(this.$router.currentRoute.path)
        },
        isMobile() {
            return window.innerWidth < 600
        },
        selectedYear() {
            if (this.fiscal_period)
                return this.fiscal_period.fiscalYear
        },
        hasAnnualizationData() {
            return this.annualization_list_filtered.filter(item => {
                    return item.annualizationStatus != commonfn.getStatusCode('Not Available')
                }).length > 0
        },
        createdCount() {
            return this.annualization_list_filtered.filter(item => {
                    return item.annualizationStatus == commonfn.getStatusCode('Created')
                }).length
        },
        forReviewCount() {
            return this.annualization_list_filtered.filter(item => {
                    return item.annualizationStatus == commonfn.getStatusCode('For Review')
                }).length
        },
        unProcessedCount() {
            return this.annualization_list_filtered.filter(item => {
                    return item.annualizationStatus == commonfn.getStatusCode('Not Available')
                }).length
        },
        approvedCount() {
            return this.annualization_list_filtered.filter(item => {
                    return item.annualizationStatus == commonfn.getStatusCode('Approved') &&
                            item.finalAdjustments >=0
                }).length
        },
        processedCount() {
            return this.annualization_list_filtered.filter(item => {
                    return item.annualizationStatus == commonfn.getStatusCode('Created') ||
                        item.annualizationStatus == commonfn.getStatusCode('Approved') ||
                        item.annualizationStatus == commonfn.getStatusCode('Rejected') ||
                        item.annualizationStatus == commonfn.getStatusCode('Adjustments Processed')
                }).length
        },
        isClosedFiscalPeriod() {
            if (this.fiscal_period)
                return this.fiscal_period.fiscalPeriodStatus == commonfn.getStatusCode('Closed')
        },
        overAllStatus() {
            const total = this.annualization_list.length
            const processed = this.processedCount

            // Default state
            const data = {
                status: 'Not Started',
                class: 'white black--text'
            }
            if (processed === 0) {
                return data           
            }
            if (processed === total && total > 0) {
                return {
                status: 'Completed',
                class: 'green white--text'
                }
            }
            return {
                status: 'In Progress',
                class: 'orange white--text'
            }
        },
        hasMissingCompanyDetails() {
            if (this.company_details) {
                return !this.company_details.companyTIN ||
                        !this.company_details.branchCode
            }
            return true
        },
        forProcessCount() {
            return this.annualization_list_filtered.filter(item => {
                return item.payrollStatus == commonfn.getStatusCode('Completed') &&
                    (
                        item.annualizationStatus == commonfn.getStatusCode('Not Available') ||
                        item.annualizationStatus == commonfn.getStatusCode('Created') ||
                        item.annualizationStatus == commonfn.getStatusCode('Rejected') 
                    )
                }).length
        }
    }
}
</script>